/**
 * Demo / sample measure records for the Measures Tracker component.
 * Sourced from real TrustMark database exports.
 */

export const DEMO_DATA = [
  // ── 15 POPLAR ROAD - Solar PV (Status 4) ──────────────────────
  {
    Id: "C61B4646-DD75-4A99-CA72-08DE842E42E3",
    CreatedUtc: "2026-03-26T11:15:56Z",
    UpdatedUtc: "2026-03-27T12:51:19Z",
    JobId: "2AD6F2BE-968D-4146-4306-08DE10D817D7",
    MeasureName: null,
    MeasureStatus: 4,
    InstallUtc: "2026-03-04T00:00:00Z",
    HandoverUtc: "2026-03-04T00:00:00Z",
    SignedOffUtc: null,
    CancelledUtc: null,
    IsManual: 1,
    MeasureReference: null,
    InstallationCost: null,
    PasMeasureName: "Solar Photovoltaics",
    PasMeasureType: "Solar Photovoltaics",
    LotName: null,
    ProjectStageName: "Project Stage 1",
    ProjectStageStatus: 4,
    JobUId: "60843747",
    SingleLineAddress: "15 POPLAR ROAD CANVEY ISLAND ESSEX SS8 7BN",
    AddressPostcode: "SS8 7BN",
    JobStatusId: 4,
    JobTypeId: 1,
    CompanyId: "DA9F3718-FAD0-468B-A98B-08D7F19416B3",
    CompanyName: "Happy Energy Solutions Ltd",
    CreatedByName: "Ryan Hayward",
    UpdatedByName: "",
    SignedOffByName: "",
    CancelledByName: "",
    EvidenceCount: 5,
    StageCount: 4,
    SiteVisitCount: 0,
    EcoStatus: 1,
    EcoMeasureName: null,
    TrustMarkUmr: null,
    SimpleMeasureDetails: {
      pasMeasureName: "Solar Photovoltaics",
      trustMarkMeasureType: "DW-231",
      pasMeasureType: "Solar Photovoltaics",
      operativeCertificationReference: "99416587",
      mcsCertificateNumber: "MCS-02659983-V",
      workDescription: "Solar PV",
      has100percentMeasureInstalled: "Yes",
      measureAssignedToInstallationPartner: false,
      subInstallerYesNo: false,
      trustmarkLicenceNumber: "aa34276f-8860-49b7-0680-08de12d89859",
      accreditationSchemeId: "6ec3e831-cc79-4206-01e7-08dbf050a14a",
      subcontractorYN: true,
      subcontractorName: "Saving Energy Ltd",
      measureGuarantee: "Qualitymark Protection / GDGC - Insurance Backed Guarantee (IBG)",
      guaranteeStartDate: "2026-03-04",
      wallGuaranteeCertificateNumber: "QMP/1905602/26/G2B8/754396",
      productManufacturer: "UKSOL",
      productModel: "UKS-S108/M10N-440",
      productVersionYN: false,
      productSerialYN: false,
      productUnits: "Items",
      productValue: 8,
      innovationMeasure: "N/A",
      ecoScheme: "None",
    },
    RawMeasureDetails: [
      {id:"1212126989",answer:{userItems:[],selectedItems:["702030"]},visible:true,type:"list-question"},
      {id:"805604",answer:"DW-231",visible:true,type:"text-question"},
      {id:"805389",answer:{userItems:[],selectedItems:["9984279"]},visible:true,type:"list-question"},
      {id:"804358",answer:"99416587",visible:true,type:"text-question"},
      {id:"806037",answer:"",visible:false,type:"yes-no-question"},
      {id:"1212128673",answer:"MCS-02659983-V",visible:true,type:"text-question"},
      {id:"1212126992",answer:"Solar PV",visible:true,type:"text-question"},
      {id:"1212127279",answer:{userItems:[],selectedItems:["700447"]},visible:true,type:"list-question"},
      {id:"1212128642",answer:"",visible:false,type:"text-question"},
      {id:"58648",answer:false,visible:true,type:"yes-no-question"},
      {id:"1212127209",answer:false,visible:true,type:"yes-no-question"},
      {id:"58651",answer:true,visible:true,type:"label-question"},
      {id:"1212126991",answer:"aa34276f-8860-49b7-0680-08de12d89859",visible:true,type:"text-question"},
      {id:"813393",answer:"6ec3e831-cc79-4206-01e7-08dbf050a14a",visible:true,type:"text-question"},
      {id:"829747",answer:true,visible:true,type:"yes-no-question"},
      {id:"829748",answer:"Saving Energy Ltd",visible:true,type:"text-question"},
      {id:"1212129877",answer:{userItems:[],selectedItems:["7030791"]},visible:true,type:"list-question"},
      {id:"1212129888",answer:"2026-03-04",visible:true,type:"date-time-question"},
      {id:"1212128646",answer:"QMP/1905602/26/G2B8/754396",visible:true,type:"text-question"},
      {id:"48051",answer:"UKSOL",visible:true,type:"text-question"},
      {id:"59220",answer:"UKS-S108/M10N-440",visible:true,type:"text-question"},
      {id:"59221",answer:false,visible:true,type:"yes-no-question"},
      {id:"59223",answer:false,visible:true,type:"yes-no-question"},
      {id:"59225",answer:{userItems:[],selectedItems:["9977143"]},visible:true,type:"list-question"},
      {id:"59226",answer:8,visible:true,type:"numeric-question"},
      {id:"1212128677",answer:{userItems:[],selectedItems:["702071"]},visible:true,type:"list-question"},
      {id:"56940",answer:{userItems:[],selectedItems:["9974042"]},visible:true,type:"list-question"},
    ],
    DefaultMeasureDetails: {
      id:"779",visible:true,type:"standard-survey",answer:"",answers:[
        {id:"125153",visible:true,type:"standard-section",answers:[
          {id:"1212126989",visible:true,type:"list-question",shortQuestionText:"pasMeasureName",answer:{userItems:[],selectedItems:["702030"]},answers:[]},
          {id:"805604",visible:true,type:"text-question",shortQuestionText:"trustMarkMeasureType",answer:"DW-231",answers:[]},
          {id:"805389",visible:true,type:"list-question",shortQuestionText:"pasMeasureType",answer:{userItems:[],selectedItems:["9984279"]},answers:[]},
          {id:"804358",visible:true,type:"text-question",shortQuestionText:"operativeCertificationReference",answer:"99416587",answers:[]},
          {id:"806037",visible:false,type:"yes-no-question",shortQuestionText:"smartTrvInstalled",answer:"",answers:[]},
          {id:"1212128673",visible:true,type:"text-question",shortQuestionText:"mcsCertificateNumber",answer:"MCS-02659983-V",answers:[]},
          {id:"1212126992",visible:true,type:"text-question",shortQuestionText:"workDescription",answer:"Solar PV",answers:[]},
          {id:"1212127279",visible:true,type:"list-question",shortQuestionText:"has100percentMeasureInstalled",answer:{userItems:[],selectedItems:["700447"]},answers:[]},
          {id:"1212128642",visible:false,type:"text-question",shortQuestionText:"evidenceWhy100PercentMeasureNotInstalled",answer:"",answers:[]},
          {id:"58648",visible:true,type:"yes-no-question",shortQuestionText:"measureAssignedToInstallationPartner",answer:false,answers:[]},
          {id:"1212127209",visible:true,type:"yes-no-question",shortQuestionText:"subInstallerYesNo",answer:false,answers:[]},
          {id:"58651",visible:true,type:"label-question",answer:true,answers:[]},
          {id:"1212126991",visible:true,type:"text-question",shortQuestionText:"trustmarkLicenceNumber",answer:"aa34276f-8860-49b7-0680-08de12d89859",answers:[]},
          {id:"813393",visible:true,type:"text-question",shortQuestionText:"accreditationSchemeId",answer:"6ec3e831-cc79-4206-01e7-08dbf050a14a",answers:[]},
          {id:"829747",visible:true,type:"yes-no-question",shortQuestionText:"subcontractorYN",answer:true,answers:[]},
          {id:"829748",visible:true,type:"text-question",shortQuestionText:"subcontractorName",answer:"Saving Energy Ltd",answers:[]},
        ]},
        {id:"125324",visible:true,type:"standard-section",answers:[
          {id:"1212129877",visible:true,type:"list-question",shortQuestionText:"measureGuarantee",answer:{userItems:[],selectedItems:["7030791"]},answers:[]},
          {id:"1212129888",visible:true,type:"date-time-question",shortQuestionText:"guaranteeStartDate",answer:"2026-03-04",answers:[]},
          {id:"1212128646",visible:true,type:"text-question",shortQuestionText:"wallGuaranteeCertificateNumber",answer:"QMP/1905602/26/G2B8/754396",answers:[]},
          {id:"48051",visible:true,type:"text-question",shortQuestionText:"productManufacturer",answer:"UKSOL",answers:[]},
          {id:"59220",visible:true,type:"text-question",shortQuestionText:"productModel",answer:"UKS-S108/M10N-440",answers:[]},
          {id:"59221",visible:true,type:"yes-no-question",shortQuestionText:"productVersionYN",answer:false,answers:[]},
          {id:"59222",visible:false,type:"text-question",shortQuestionText:"productVersionDetails",answer:"",answers:[]},
          {id:"59223",visible:true,type:"yes-no-question",shortQuestionText:"productSerialYN",answer:false,answers:[]},
          {id:"59224",visible:false,type:"text-question",shortQuestionText:"productSerialDetails",answer:"",answers:[]},
          {id:"59225",visible:true,type:"list-question",shortQuestionText:"productUnits",answer:{userItems:[],selectedItems:["9977143"]},answers:[]},
          {id:"59226",visible:true,type:"numeric-question",shortQuestionText:"productValue",answer:8,answers:[]},
          {id:"1212128677",visible:true,type:"list-question",shortQuestionText:"innovationMeasure",answer:{userItems:[],selectedItems:["702071"]},answers:[]},
          {id:"1212130487",visible:false,type:"text-question",shortQuestionText:"innovationMeasureNumber",answer:"",answers:[]},
        ]},
        {id:"125325",visible:true,type:"standard-section",answers:[
          {id:"56940",visible:true,type:"list-question",shortQuestionText:"ecoScheme",answer:{userItems:[],selectedItems:["9974042"]},answers:[]},
          {id:"801826",visible:false,type:"yes-no-question",shortQuestionText:"swmrEligible",answer:"",answers:[]},
          {id:"806115",visible:false,type:"list-question",shortQuestionText:"swiInsMat",answer:"",answers:[]},
          {id:"806116",visible:false,type:"numeric-question",shortQuestionText:"swiInsThick",answer:"",answers:[]},
          {id:"806117",visible:false,type:"list-question",shortQuestionText:"swiWallType",answer:"",answers:[]},
          {id:"801633",visible:false,type:"yes-no-question",shortQuestionText:"minReqExeYN",answer:"",answers:[]},
          {id:"801634",visible:false,type:"list-question",shortQuestionText:"minReqExeReason",answer:"",answers:[]},
          {id:"1212130446",visible:false,type:"text-question",shortQuestionText:"pasId",answer:"",answers:[]},
          {id:"801534",visible:false,type:"list-question",shortQuestionText:"insReqMet",answer:"",answers:[]},
          {id:"59316",visible:false,type:"list-question",shortQuestionText:"dhsConsumerPro",answer:"",answers:[]},
          {id:"806337",visible:false,type:"list-question",shortQuestionText:"preAssMeth",answer:"",answers:[]},
          {id:"806348",visible:false,type:"text-question",shortQuestionText:"preAssRefEPC",answer:"",answers:[]},
          {id:"806339",visible:false,type:"list-question",shortQuestionText:"postAssMeth",answer:"",answers:[]},
          {id:"806349",visible:false,type:"text-question",shortQuestionText:"postAssRefEPC",answer:"",answers:[]},
          {id:"47596",visible:false,type:"yes-no-question",shortQuestionText:"OtherInsulationExtraction",answer:"",answers:[]},
          {id:"1212128672",visible:false,type:"yes-no-question",shortQuestionText:"cwiExtraction",answer:"",answers:[]},
          {id:"52063",visible:false,type:"yes-no-question",shortQuestionText:"doesPropertyContainRenewableHeating",answer:"",answers:[]},
        ]},
      ]
    },
  },

  // ── 86 GROOM PARK - Solar PV (Status 6, Signed Off) ───────────
  {
    Id: "3D19A4F5-3E6E-4A0E-39D3-08DE842CA87D",
    CreatedUtc: "2026-03-26T10:51:01Z",
    UpdatedUtc: "2026-04-07T14:15:59Z",
    JobId: "AF6C539B-8792-4878-429B-08DE10D817D7",
    MeasureName: null,
    MeasureStatus: 6,
    InstallUtc: "2026-01-09T00:00:00Z",
    HandoverUtc: "2026-01-09T00:00:00Z",
    SignedOffUtc: "2026-03-26T11:43:55Z",
    CancelledUtc: null,
    IsManual: 1,
    MeasureReference: null,
    InstallationCost: null,
    PasMeasureName: "Solar Photovoltaics",
    PasMeasureType: "Solar Photovoltaics",
    LotName: null,
    ProjectStageName: "Project Stage 1",
    ProjectStageStatus: 6,
    TrustMarkMeasureId: "6b3e0fa1-c8f2-43c3-9113-69e33d4766ff",
    SubInstallerTrustMarkLicenceNumber: null,
    JobUId: "60843640",
    SingleLineAddress: "86 GROOM PARK CLACTON ON SEA ESSEX CO15 3NN",
    AddressPostcode: "CO15 3NN",
    JobStatusId: 6,
    JobTypeId: 1,
    CompanyId: "DA9F3718-FAD0-468B-A98B-08D7F19416B3",
    CompanyName: "Happy Energy Solutions Ltd",
    CreatedByName: "Charlie Linthwaite",
    UpdatedByName: "",
    SignedOffByName: "",
    CancelledByName: "",
    EvidenceCount: 16,
    StageCount: 4,
    SiteVisitCount: 0,
    EcoStatus: 1,
    EcoMeasureName: null,
    TrustMarkUmr: "P522092SVBY",
    SimpleMeasureDetails: {
      pasMeasureName: "Solar Photovoltaics",
      trustMarkMeasureType: "DW-231",
      pasMeasureType: "Solar Photovoltaics",
      operativeCertificationReference: "99416587",
      mcsCertificateNumber: "MCS-02594088-B",
      workDescription: "Solar PV",
      has100percentMeasureInstalled: "Yes",
      measureAssignedToInstallationPartner: true,
      subInstallerYesNo: false,
      accreditationSchemeId: "7a372cec-93e9-4b0f-01e3-08dbf050a14a",
      subcontractorYN: true,
      subcontractorName: "Saving Energy Ltd",
      measureGuarantee: "Qualitymark Protection / GDGC - Insurance Backed Guarantee (IBG)",
      guaranteeStartDate: "2026-01-09",
      wallGuaranteeCertificateNumber: "QMP/1875280/26/D0Z5/711695",
      productManufacturer: "UKSOL",
      productModel: "UKS-S108/M10N-440",
      productVersionYN: false,
      productSerialYN: false,
      productUnits: "Items",
      productValue: 8,
      innovationMeasure: "N/A",
      ecoScheme: "None",
    },
    RawMeasureDetails: [
      {id:"1212126989",answer:{userItems:[],selectedItems:["702030"]},visible:true,type:"list-question"},
      {id:"805604",answer:"DW-231",visible:true,type:"text-question"},
      {id:"805389",answer:{userItems:[],selectedItems:["9984279"]},visible:true,type:"list-question"},
      {id:"804358",answer:"99416587",visible:true,type:"text-question"},
      {id:"806037",answer:"",visible:false,type:"yes-no-question"},
      {id:"1212128673",answer:"MCS-02594088-B",visible:true,type:"text-question"},
      {id:"1212126992",answer:"Solar PV",visible:true,type:"text-question"},
      {id:"1212127279",answer:{userItems:[],selectedItems:["700447"]},visible:true,type:"list-question"},
      {id:"58648",answer:true,visible:true,type:"yes-no-question"},
      {id:"1212127209",answer:false,visible:true,type:"yes-no-question"},
      {id:"58650",answer:true,visible:true,type:"label-question"},
      {id:"813393",answer:"7a372cec-93e9-4b0f-01e3-08dbf050a14a",visible:true,type:"text-question"},
      {id:"829747",answer:true,visible:true,type:"yes-no-question"},
      {id:"829748",answer:"Saving Energy Ltd",visible:true,type:"text-question"},
      {id:"1212129877",answer:{userItems:[],selectedItems:["7030791"]},visible:true,type:"list-question"},
      {id:"1212129888",answer:"2026-01-09",visible:true,type:"date-time-question"},
      {id:"1212128646",answer:"QMP/1875280/26/D0Z5/711695",visible:true,type:"text-question"},
      {id:"48051",answer:"UKSOL",visible:true,type:"text-question"},
      {id:"59220",answer:"UKS-S108/M10N-440",visible:true,type:"text-question"},
      {id:"59221",answer:false,visible:true,type:"yes-no-question"},
      {id:"59223",answer:false,visible:true,type:"yes-no-question"},
      {id:"59225",answer:{userItems:[],selectedItems:["9977143"]},visible:true,type:"list-question"},
      {id:"59226",answer:8,visible:true,type:"numeric-question"},
      {id:"1212128677",answer:{userItems:[],selectedItems:["702071"]},visible:true,type:"list-question"},
      {id:"56940",answer:{userItems:[],selectedItems:["9974042"]},visible:true,type:"list-question"},
    ],
    DefaultMeasureDetails: {
      id:"779",visible:true,type:"standard-survey",answer:"",answers:[
        {id:"125153",visible:true,type:"standard-section",answers:[
          {id:"1212126989",visible:true,type:"list-question",shortQuestionText:"pasMeasureName",answer:{userItems:[],selectedItems:["702030"]},answers:[]},
          {id:"805604",visible:true,type:"text-question",shortQuestionText:"trustMarkMeasureType",answer:"DW-231",answers:[]},
          {id:"805389",visible:true,type:"list-question",shortQuestionText:"pasMeasureType",answer:{userItems:[],selectedItems:["9984279"]},answers:[]},
          {id:"804358",visible:true,type:"text-question",shortQuestionText:"operativeCertificationReference",answer:"99416587",answers:[]},
          {id:"806037",visible:false,type:"yes-no-question",shortQuestionText:"smartTrvInstalled",answer:"",answers:[]},
          {id:"1212128673",visible:true,type:"text-question",shortQuestionText:"mcsCertificateNumber",answer:"MCS-02594088-B",answers:[]},
          {id:"1212126992",visible:true,type:"text-question",shortQuestionText:"workDescription",answer:"Solar PV",answers:[]},
          {id:"1212127279",visible:true,type:"list-question",shortQuestionText:"has100percentMeasureInstalled",answer:{userItems:[],selectedItems:["700447"]},answers:[]},
          {id:"1212128642",visible:false,type:"text-question",shortQuestionText:"evidenceWhy100PercentMeasureNotInstalled",answer:"",answers:[]},
          {id:"58648",visible:true,type:"yes-no-question",shortQuestionText:"measureAssignedToInstallationPartner",answer:true,answers:[]},
          {id:"1212127209",visible:true,type:"yes-no-question",shortQuestionText:"subInstallerYesNo",answer:false,answers:[]},
          {id:"58650",visible:true,type:"label-question",answer:true,answers:[]},
          {id:"1212126991",visible:false,type:"text-question",shortQuestionText:"trustmarkLicenceNumber",answer:"",answers:[]},
          {id:"813393",visible:true,type:"text-question",shortQuestionText:"accreditationSchemeId",answer:"7a372cec-93e9-4b0f-01e3-08dbf050a14a",answers:[]},
          {id:"829747",visible:true,type:"yes-no-question",shortQuestionText:"subcontractorYN",answer:true,answers:[]},
          {id:"829748",visible:true,type:"text-question",shortQuestionText:"subcontractorName",answer:"Saving Energy Ltd",answers:[]},
        ]},
        {id:"125324",visible:true,type:"standard-section",answers:[
          {id:"1212129877",visible:true,type:"list-question",shortQuestionText:"measureGuarantee",answer:{userItems:[],selectedItems:["7030791"]},answers:[]},
          {id:"1212129888",visible:true,type:"date-time-question",shortQuestionText:"guaranteeStartDate",answer:"2026-01-09",answers:[]},
          {id:"1212128646",visible:true,type:"text-question",shortQuestionText:"wallGuaranteeCertificateNumber",answer:"QMP/1875280/26/D0Z5/711695",answers:[]},
          {id:"48051",visible:true,type:"text-question",shortQuestionText:"productManufacturer",answer:"UKSOL",answers:[]},
          {id:"59220",visible:true,type:"text-question",shortQuestionText:"productModel",answer:"UKS-S108/M10N-440",answers:[]},
          {id:"59221",visible:true,type:"yes-no-question",shortQuestionText:"productVersionYN",answer:false,answers:[]},
          {id:"59222",visible:false,type:"text-question",shortQuestionText:"productVersionDetails",answer:"",answers:[]},
          {id:"59223",visible:true,type:"yes-no-question",shortQuestionText:"productSerialYN",answer:false,answers:[]},
          {id:"59224",visible:false,type:"text-question",shortQuestionText:"productSerialDetails",answer:"",answers:[]},
          {id:"59225",visible:true,type:"list-question",shortQuestionText:"productUnits",answer:{userItems:[],selectedItems:["9977143"]},answers:[]},
          {id:"59226",visible:true,type:"numeric-question",shortQuestionText:"productValue",answer:8,answers:[]},
          {id:"1212128677",visible:true,type:"list-question",shortQuestionText:"innovationMeasure",answer:{userItems:[],selectedItems:["702071"]},answers:[]},
          {id:"1212130487",visible:false,type:"text-question",shortQuestionText:"innovationMeasureNumber",answer:"",answers:[]},
        ]},
        {id:"125325",visible:true,type:"standard-section",answers:[
          {id:"56940",visible:true,type:"list-question",shortQuestionText:"ecoScheme",answer:{userItems:[],selectedItems:["9974042"]},answers:[]},
          {id:"801826",visible:false,type:"yes-no-question",shortQuestionText:"swmrEligible",answer:"",answers:[]},
          {id:"801633",visible:false,type:"yes-no-question",shortQuestionText:"minReqExeYN",answer:"",answers:[]},
          {id:"52063",visible:false,type:"yes-no-question",shortQuestionText:"doesPropertyContainRenewableHeating",answer:"",answers:[]},
        ]},
      ]
    },
  },

  // ── 9 NAZE PARK ROAD - HHRSH / Electric Storage Heater (Status 6) ─
  {
    Id: "8209DE50-5EEC-478A-5F4B-08DE842D7954",
    CreatedUtc: "2026-03-18T13:08:29Z",
    UpdatedUtc: "2026-03-18T16:59:36Z",
    JobId: "6CB38713-78C7-4CBC-42F8-08DE10D817D7",
    MeasureName: null,
    MeasureStatus: 6,
    InstallUtc: "2026-02-19T00:00:00Z",
    HandoverUtc: "2026-02-19T00:00:00Z",
    SignedOffUtc: "2026-03-18T16:47:55Z",
    CancelledUtc: null,
    IsManual: 1,
    MeasureReference: null,
    InstallationCost: null,
    DesignCompleted: null,
    TrustMarkMeasureId: "49ded699-e7f1-4e54-857f-c62cc90c1b98",
    PasMeasureName: null,
    PasMeasureType: null,
    LotName: null,
    ProjectStageName: "Project Stage 1",
    ProjectStageStatus: 6,
    SubInstallerTrustMarkLicenceNumber: null,
    JobUId: "60843733",
    SingleLineAddress: "9 NAZE PARK ROAD WALTON ON THE NAZE ESSEX CO14 8JN",
    AddressPostcode: "CO14 8JN",
    JobStatusId: 6,
    JobTypeId: 1,
    CompanyId: "DA9F3718-FAD0-468B-A98B-08D7F19416B3",
    CompanyName: "Happy Energy Solutions Ltd",
    CreatedByName: "Charlie Linthwaite",
    UpdatedByName: "",
    SignedOffByName: "",
    CancelledByName: "",
    EvidenceCount: 10,
    StageCount: 4,
    SiteVisitCount: 0,
    EcoStatus: 1,
    EcoMeasureName: null,
    TrustMarkUmr: "P514620GHZL",
    SimpleMeasureDetails: {
      "58650": true,
      pasMeasureName: "Replacement of Electric Storage Heaters",
      trustMarkMeasureType: "DW-514",
      pasMeasureType: "Electric Storage Heater (Upgrades)",
      workDescription: "Installation of HHRSH",
      has100percentMeasureInstalled: "Yes",
      measureAssignedToInstallationPartner: false,
      subInstallerYesNo: true,
      accreditationSchemeId: "bb7ec27b-baff-455b-2179-08dbf050722f",
      subcontractorYN: true,
      subcontractorName: "Saving Energy Ltd",
      measureGuarantee: "Qualitymark Protection / GDGC - Insurance Backed Guarantee (IBG)",
      guaranteeStartDate: "2026-02-19",
      wallGuaranteeCertificateNumber: "QMP/1911141/26/X8R6/763722",
      productManufacturer: "Dimplex",
      productModel: "QMRF",
      productVersionYN: false,
      productSerialYN: false,
      productUnits: "Items",
      productValue: 3,
      innovationMeasure: "N/A",
      ecoScheme: "None",
    },
    RawMeasureDetails: null,
    DefaultMeasureDetails: null,
  },

  // ── 9 NAZE PARK ROAD - Solar PV (Status 6) ────────────────────
  {
    Id: "A01C2524-A916-4530-37BE-08DE842CA87D",
    CreatedUtc: "2026-03-18T13:07:48Z",
    UpdatedUtc: "2026-03-18T16:59:36Z",
    JobId: "6CB38713-78C7-4CBC-42F8-08DE10D817D7",
    MeasureName: null,
    MeasureStatus: 6,
    InstallUtc: "2026-02-18T00:00:00Z",
    HandoverUtc: "2026-02-19T00:00:00Z",
    SignedOffUtc: "2026-03-18T16:48:03Z",
    CancelledUtc: null,
    IsManual: 1,
    MeasureReference: null,
    InstallationCost: null,
    DesignCompleted: null,
    TrustMarkMeasureId: "5cdce75d-0bc1-4ddd-9089-07beef5b43ea",
    PasMeasureName: null,
    PasMeasureType: null,
    LotName: null,
    ProjectStageName: "Project Stage 1",
    ProjectStageStatus: 6,
    SubInstallerTrustMarkLicenceNumber: "1666523",
    JobUId: "60843733",
    SingleLineAddress: "9 NAZE PARK ROAD WALTON ON THE NAZE ESSEX CO14 8JN",
    AddressPostcode: "CO14 8JN",
    JobStatusId: 6,
    JobTypeId: 1,
    CompanyId: "DA9F3718-FAD0-468B-A98B-08D7F19416B3",
    CompanyName: "Happy Energy Solutions Ltd",
    CreatedByName: "Charlie Linthwaite",
    UpdatedByName: "",
    SignedOffByName: "",
    CancelledByName: "",
    EvidenceCount: 12,
    StageCount: 4,
    SiteVisitCount: 0,
    EcoStatus: 1,
    EcoMeasureName: null,
    TrustMarkUmr: "P514620WWPH",
    SimpleMeasureDetails: {
      "58651": true,
      pasMeasureName: "Solar Photovoltaics",
      trustMarkMeasureType: "DW-231",
      pasMeasureType: "Solar Photovoltaics",
      operativeCertificationReference: "99416587",
      mcsCertificateNumber: "MCS-02641373-O",
      workDescription: "Solar PV",
      has100percentMeasureInstalled: "Yes",
      measureAssignedToInstallationPartner: false,
      subInstallerYesNo: false,
      trustmarkLicenceNumber: "aa34276f-8860-49b7-0680-08de12d89859",
      accreditationSchemeId: "6ec3e831-cc79-4206-01e7-08dbf050a14a",
      subcontractorYN: true,
      subcontractorName: "Saving Energy Ltd",
      measureGuarantee: "Qualitymark Protection / GDGC - Insurance Backed Guarantee (IBG)",
      guaranteeStartDate: "2026-02-18",
      wallGuaranteeCertificateNumber: "QMP/1897434/26/F3P6/741591",
      productManufacturer: "UKSOL",
      productModel: "UKS-S108/M10N-440",
      productVersionYN: false,
      productSerialYN: false,
      productUnits: "Items",
      productValue: 8,
      innovationMeasure: "N/A",
      ecoScheme: "None",
    },
    RawMeasureDetails: null,
    DefaultMeasureDetails: null,
  },

  // ── 125 WARWICK ROAD - (Status 1) ─────────────────────────────
  {
    Id: "A27161E1-38B8-4673-6E37-08DE57F498F4",
    CreatedUtc: "2026-03-18T09:02:48Z",
    UpdatedUtc: "2026-03-18T09:02:48Z",
    JobId: "A660FB4D-1E61-4C22-9CED-08DE57F5C532",
    MeasureName: null,
    MeasureStatus: 1,
    InstallUtc: null,
    HandoverUtc: null,
    SignedOffUtc: null,
    CancelledUtc: null,
    IsManual: 0,
    MeasureReference: null,
    InstallationCost: null,
    DesignCompleted: null,
    TrustMarkMeasureId: null,
    PasMeasureName: null,
    PasMeasureType: null,
    LotName: null,
    ProjectStageName: "Project Stage 1",
    ProjectStageStatus: 1,
    SubInstallerTrustMarkLicenceNumber: null,
    JobUId: "60883046",
    SingleLineAddress: "125 WARWICK ROAD RAYLEIGH ESSEX SS6 8TF",
    AddressPostcode: "SS6 8TF",
    JobStatusId: 1,
    JobTypeId: 1,
    CompanyId: "DA9F3718-FAD0-468B-A98B-08D7F19416B3",
    CompanyName: "Happy Energy Solutions Ltd",
    CreatedByName: "",
    UpdatedByName: "",
    SignedOffByName: "",
    CancelledByName: "",
    EvidenceCount: 0,
    StageCount: 4,
    SiteVisitCount: 0,
    EcoStatus: 1,
    EcoMeasureName: null,
    TrustMarkUmr: null,
    SimpleMeasureDetails: null,
    RawMeasureDetails: null,
    DefaultMeasureDetails: null,
  },

  // ── 2 KEYSLAND - (Status 1) ───────────────────────────────────
  {
    Id: "071EFE86-13DE-4B8E-6DAC-08DE57F498F4",
    CreatedUtc: "2026-03-17T21:29:52Z",
    UpdatedUtc: "2026-03-17T21:29:52Z",
    JobId: "AA044B72-BAAB-40AD-9CE6-08DE57F5C532",
    MeasureName: null,
    MeasureStatus: 1,
    InstallUtc: null,
    HandoverUtc: null,
    SignedOffUtc: null,
    CancelledUtc: null,
    IsManual: 0,
    MeasureReference: null,
    InstallationCost: null,
    DesignCompleted: null,
    TrustMarkMeasureId: null,
    PasMeasureName: null,
    PasMeasureType: null,
    LotName: null,
    ProjectStageName: "Project Stage 1",
    ProjectStageStatus: 1,
    SubInstallerTrustMarkLicenceNumber: null,
    JobUId: "60883039",
    SingleLineAddress: "2 KEYSLAND BENFLEET ESSEX SS7 3TW",
    AddressPostcode: "SS7 3TW",
    JobStatusId: 1,
    JobTypeId: 1,
    CompanyId: "DA9F3718-FAD0-468B-A98B-08D7F19416B3",
    CompanyName: "Happy Energy Solutions Ltd",
    CreatedByName: "",
    UpdatedByName: "",
    SignedOffByName: "",
    CancelledByName: "",
    EvidenceCount: 0,
    StageCount: 4,
    SiteVisitCount: 0,
    EcoStatus: 1,
    EcoMeasureName: null,
    TrustMarkUmr: null,
    SimpleMeasureDetails: null,
    RawMeasureDetails: null,
    DefaultMeasureDetails: null,
  },

  // ── 25 HOLTYNGE - (Status 1) ──────────────────────────────────
  {
    Id: "3A978F47-4AED-474D-6D6B-08DE57F498F4",
    CreatedUtc: "2026-03-17T20:16:13Z",
    UpdatedUtc: "2026-03-17T20:16:13Z",
    JobId: "40FF493A-7AD8-42EC-9DFD-08DE57F5C532",
    MeasureName: null,
    MeasureStatus: 1,
    InstallUtc: null,
    HandoverUtc: null,
    SignedOffUtc: null,
    CancelledUtc: null,
    IsManual: 0,
    MeasureReference: null,
    InstallationCost: null,
    DesignCompleted: null,
    TrustMarkMeasureId: null,
    PasMeasureName: null,
    PasMeasureType: null,
    LotName: null,
    ProjectStageName: "Project Stage 1",
    ProjectStageStatus: 1,
    SubInstallerTrustMarkLicenceNumber: null,
    JobUId: "60885682",
    SingleLineAddress: "25 HOLTYNGE BENFLEET ESSEX SS7 5QH",
    AddressPostcode: "SS7 5QH",
    JobStatusId: 1,
    JobTypeId: 1,
    CompanyId: "DA9F3718-FAD0-468B-A98B-08D7F19416B3",
    CompanyName: "Happy Energy Solutions Ltd",
    CreatedByName: "",
    UpdatedByName: "",
    SignedOffByName: "",
    CancelledByName: "",
    EvidenceCount: 0,
    StageCount: 4,
    SiteVisitCount: 0,
    EcoStatus: 1,
    EcoMeasureName: null,
    TrustMarkUmr: null,
    SimpleMeasureDetails: null,
    RawMeasureDetails: null,
    DefaultMeasureDetails: null,
  },

  // ── 37 CHIGNAL ROAD - (Status 2) ──────────────────────────────
  {
    Id: "489F80F8-D62C-4B0B-9C6E-08DE57F518A9",
    CreatedUtc: "2026-03-17T13:03:17Z",
    UpdatedUtc: "2026-03-17T13:03:17Z",
    JobId: "8B61C606-A130-404F-4338-08DE10D817D7",
    MeasureName: null,
    MeasureStatus: 2,
    InstallUtc: null,
    HandoverUtc: null,
    SignedOffUtc: null,
    CancelledUtc: null,
    IsManual: 1,
    MeasureReference: null,
    InstallationCost: null,
    DesignCompleted: null,
    TrustMarkMeasureId: null,
    PasMeasureName: null,
    PasMeasureType: null,
    LotName: null,
    ProjectStageName: "Project Stage 1",
    ProjectStageStatus: 2,
    SubInstallerTrustMarkLicenceNumber: null,
    JobUId: "60843797",
    SingleLineAddress: "37 CHIGNAL ROAD CHELMSFORD ESSEX CM1 2JA",
    AddressPostcode: "CM1 2JA",
    JobStatusId: 2,
    JobTypeId: 1,
    CompanyId: "DA9F3718-FAD0-468B-A98B-08D7F19416B3",
    CompanyName: "Happy Energy Solutions Ltd",
    CreatedByName: "Charlie Linthwaite",
    UpdatedByName: "Charlie Linthwaite",
    SignedOffByName: "",
    CancelledByName: "",
    EvidenceCount: 0,
    StageCount: 4,
    SiteVisitCount: 0,
    EcoStatus: 1,
    EcoMeasureName: null,
    TrustMarkUmr: null,
    SimpleMeasureDetails: null,
    RawMeasureDetails: null,
    DefaultMeasureDetails: null,
  },

  // ── 31 ALLEYNE WAY - (Status 2) ───────────────────────────────
  {
    Id: "A9410423-6A10-40EF-9C44-08DE57F518A9",
    CreatedUtc: "2026-03-17T08:38:53Z",
    UpdatedUtc: "2026-03-17T08:38:53Z",
    JobId: "623D0A87-5886-4462-430C-08DE10D817D7",
    MeasureName: null,
    MeasureStatus: 2,
    InstallUtc: null,
    HandoverUtc: null,
    SignedOffUtc: null,
    CancelledUtc: null,
    IsManual: 1,
    MeasureReference: null,
    InstallationCost: null,
    DesignCompleted: null,
    TrustMarkMeasureId: null,
    PasMeasureName: null,
    PasMeasureType: null,
    LotName: null,
    ProjectStageName: "Project Stage 1",
    ProjectStageStatus: 2,
    SubInstallerTrustMarkLicenceNumber: null,
    JobUId: "60843753",
    SingleLineAddress: "31 ALLEYNE WAY CLACTON-ON-SEA ESSEX CO15 2RD",
    AddressPostcode: "CO15 2RD",
    JobStatusId: 2,
    JobTypeId: 1,
    CompanyId: "DA9F3718-FAD0-468B-A98B-08D7F19416B3",
    CompanyName: "Happy Energy Solutions Ltd",
    CreatedByName: "",
    UpdatedByName: "",
    SignedOffByName: "",
    CancelledByName: "",
    EvidenceCount: 0,
    StageCount: 4,
    SiteVisitCount: 0,
    EcoStatus: 1,
    EcoMeasureName: null,
    TrustMarkUmr: null,
    SimpleMeasureDetails: null,
    RawMeasureDetails: null,
    DefaultMeasureDetails: null,
  },

  // ── 43 CAMELLIA CRESCENT - (Status 2) ─────────────────────────
  {
    Id: "C3FE4CBC-9133-4480-6ADE-08DE57F498F4",
    CreatedUtc: "2026-03-16T19:17:28Z",
    UpdatedUtc: "2026-04-08T13:46:13Z",
    JobId: "19B6D7DD-A2C2-4DD1-9BBC-08DE57F5C532",
    MeasureName: null,
    MeasureStatus: 2,
    InstallUtc: null,
    HandoverUtc: null,
    SignedOffUtc: null,
    CancelledUtc: null,
    IsManual: 0,
    MeasureReference: null,
    InstallationCost: null,
    DesignCompleted: null,
    TrustMarkMeasureId: null,
    PasMeasureName: null,
    PasMeasureType: null,
    LotName: null,
    ProjectStageName: "Project Stage 1",
    ProjectStageStatus: 2,
    SubInstallerTrustMarkLicenceNumber: null,
    JobUId: "60874036",
    SingleLineAddress: "43 CAMELLIA CRESCENT CLACTON ON SEA ESSEX CO16 7EU",
    AddressPostcode: "CO16 7EU",
    JobStatusId: 2,
    JobTypeId: 1,
    CompanyId: "DA9F3718-FAD0-468B-A98B-08D7F19416B3",
    CompanyName: "Happy Energy Solutions Ltd",
    CreatedByName: "",
    UpdatedByName: "Ryan Hayward",
    SignedOffByName: "",
    CancelledByName: "",
    EvidenceCount: 0,
    StageCount: 4,
    SiteVisitCount: 0,
    EcoStatus: 1,
    EcoMeasureName: null,
    TrustMarkUmr: null,
    SimpleMeasureDetails: null,
    RawMeasureDetails: null,
    DefaultMeasureDetails: null,
  },

  // ── 19 POYNDER ROAD - (Status 1) ──────────────────────────────
  {
    Id: "1AFFF844-CA37-4430-67A5-08DE57F498F4",
    CreatedUtc: "2026-03-14T13:41:59Z",
    UpdatedUtc: "2026-03-14T13:41:59Z",
    JobId: "D37DE4FA-154E-41EF-9ADF-08DE57F5C532",
    MeasureName: null,
    MeasureStatus: 1,
    InstallUtc: null,
    HandoverUtc: null,
    SignedOffUtc: null,
    CancelledUtc: null,
    IsManual: 0,
    MeasureReference: null,
    InstallationCost: null,
    DesignCompleted: null,
    TrustMarkMeasureId: null,
    PasMeasureName: null,
    PasMeasureType: null,
    LotName: null,
    ProjectStageName: "Project Stage 1",
    ProjectStageStatus: 1,
    SubInstallerTrustMarkLicenceNumber: null,
    JobUId: "60871043",
    SingleLineAddress: "19 POYNDER ROAD TILBURY ESSEX RM18 8LU",
    AddressPostcode: "RM18 8LU",
    JobStatusId: 1,
    JobTypeId: 1,
    CompanyId: "DA9F3718-FAD0-468B-A98B-08D7F19416B3",
    CompanyName: "Happy Energy Solutions Ltd",
    CreatedByName: "",
    UpdatedByName: "",
    SignedOffByName: "",
    CancelledByName: "",
    EvidenceCount: 0,
    StageCount: 4,
    SiteVisitCount: 0,
    EcoStatus: 1,
    EcoMeasureName: null,
    TrustMarkUmr: null,
    SimpleMeasureDetails: null,
    RawMeasureDetails: null,
    DefaultMeasureDetails: null,
  },

  // ── 87 JAMESON ROAD - (Status 4) ──────────────────────────────
  {
    Id: "6DC6726A-B9A7-4598-8FEF-08DE5800CBCC",
    CreatedUtc: "2026-03-13T09:26:04Z",
    UpdatedUtc: "2026-04-13T07:49:45Z",
    JobId: "6807AA9E-F973-4F6A-9AD1-08DE57F5C532",
    MeasureName: null,
    MeasureStatus: 4,
    InstallUtc: "2026-03-17T00:00:00Z",
    HandoverUtc: "2026-03-17T00:00:00Z",
    SignedOffUtc: null,
    CancelledUtc: null,
    IsManual: 1,
    MeasureReference: null,
    InstallationCost: null,
    DesignCompleted: null,
    TrustMarkMeasureId: null,
    PasMeasureName: null,
    PasMeasureType: null,
    LotName: null,
    ProjectStageName: "Project Stage 1",
    ProjectStageStatus: 4,
    SubInstallerTrustMarkLicenceNumber: null,
    JobUId: "60869134",
    SingleLineAddress: "87 JAMESON ROAD CLACTON ON SEA ESSEX CO15 2AP",
    AddressPostcode: "CO15 2AP",
    JobStatusId: 4,
    JobTypeId: 1,
    CompanyId: "DA9F3718-FAD0-468B-A98B-08D7F19416B3",
    CompanyName: "Happy Energy Solutions Ltd",
    CreatedByName: "",
    UpdatedByName: "",
    SignedOffByName: "",
    CancelledByName: "",
    EvidenceCount: 6,
    StageCount: 4,
    SiteVisitCount: 0,
    EcoStatus: 1,
    EcoMeasureName: null,
    TrustMarkUmr: null,
    SimpleMeasureDetails: null,
    RawMeasureDetails: null,
    DefaultMeasureDetails: null,
  },

  // ── 2 RECTORY COTTAGES - (Status 3) ───────────────────────────
  {
    Id: "7B61DB5B-93B7-4DBB-8FEC-08DE5800CBCC",
    CreatedUtc: "2026-03-13T07:56:22Z",
    UpdatedUtc: "2026-03-27T14:52:55Z",
    JobId: "43B1B3B8-707D-4310-42BA-08DE10D817D7",
    MeasureName: null,
    MeasureStatus: 3,
    InstallUtc: null,
    HandoverUtc: null,
    SignedOffUtc: null,
    CancelledUtc: null,
    IsManual: 1,
    MeasureReference: null,
    InstallationCost: null,
    DesignCompleted: null,
    TrustMarkMeasureId: null,
    PasMeasureName: null,
    PasMeasureType: null,
    LotName: null,
    ProjectStageName: "Project Stage 1",
    ProjectStageStatus: 3,
    SubInstallerTrustMarkLicenceNumber: null,
    JobUId: "60843671",
    SingleLineAddress: "2 RECTORY COTTAGES RECTORY ROAD COLCHESTER ESSEX CO6 1DJ",
    AddressPostcode: "CO6 1DJ",
    JobStatusId: 3,
    JobTypeId: 1,
    CompanyId: "DA9F3718-FAD0-468B-A98B-08D7F19416B3",
    CompanyName: "Happy Energy Solutions Ltd",
    CreatedByName: "Ryan Hayward",
    UpdatedByName: "",
    SignedOffByName: "",
    CancelledByName: "",
    EvidenceCount: 4,
    StageCount: 4,
    SiteVisitCount: 0,
    EcoStatus: 1,
    EcoMeasureName: null,
    TrustMarkUmr: null,
    SimpleMeasureDetails: null,
    RawMeasureDetails: null,
    DefaultMeasureDetails: null,
  },

  // ── 44 WOODBERRY WAY - (Status 1) ─────────────────────────────
  {
    Id: "A7D10807-1432-4DFD-6585-08DE57F498F4",
    CreatedUtc: "2026-03-13T07:27:52Z",
    UpdatedUtc: "2026-03-13T07:27:52Z",
    JobId: "33428E26-E3B1-40E0-9ADE-08DE57F5C532",
    MeasureName: null,
    MeasureStatus: 1,
    InstallUtc: null,
    HandoverUtc: null,
    SignedOffUtc: null,
    CancelledUtc: null,
    IsManual: 0,
    MeasureReference: null,
    InstallationCost: null,
    DesignCompleted: null,
    TrustMarkMeasureId: null,
    PasMeasureName: null,
    PasMeasureType: null,
    LotName: null,
    ProjectStageName: "Project Stage 1",
    ProjectStageStatus: 1,
    SubInstallerTrustMarkLicenceNumber: null,
    JobUId: "60871042",
    SingleLineAddress: "44 WOODBERRY WAY WALTON ON THE NAZE ESSEX CO14 8EL",
    AddressPostcode: "CO14 8EL",
    JobStatusId: 1,
    JobTypeId: 1,
    CompanyId: "DA9F3718-FAD0-468B-A98B-08D7F19416B3",
    CompanyName: "Happy Energy Solutions Ltd",
    CreatedByName: "",
    UpdatedByName: "",
    SignedOffByName: "",
    CancelledByName: "",
    EvidenceCount: 0,
    StageCount: 4,
    SiteVisitCount: 0,
    EcoStatus: 1,
    EcoMeasureName: null,
    TrustMarkUmr: null,
    SimpleMeasureDetails: null,
    RawMeasureDetails: null,
    DefaultMeasureDetails: null,
  },

  // ── 40 THE STREET - (Status 2) ────────────────────────────────
  {
    Id: "57A07216-0753-4D14-657A-08DE57F498F4",
    CreatedUtc: "2026-03-13T06:36:29Z",
    UpdatedUtc: "2026-04-09T14:32:01Z",
    JobId: "1E802F3E-90BD-4BE9-9CA0-08DE57F5C532",
    MeasureName: null,
    MeasureStatus: 2,
    InstallUtc: null,
    HandoverUtc: null,
    SignedOffUtc: null,
    CancelledUtc: null,
    IsManual: 0,
    MeasureReference: null,
    InstallationCost: null,
    DesignCompleted: null,
    TrustMarkMeasureId: null,
    PasMeasureName: null,
    PasMeasureType: null,
    LotName: null,
    ProjectStageName: "Project Stage 1",
    ProjectStageStatus: 2,
    SubInstallerTrustMarkLicenceNumber: null,
    JobUId: "60880085",
    SingleLineAddress: "40 THE STREET FRINTON ON SEA ESSEX CO13 0EF",
    AddressPostcode: "CO13 0EF",
    JobStatusId: 2,
    JobTypeId: 1,
    CompanyId: "DA9F3718-FAD0-468B-A98B-08D7F19416B3",
    CompanyName: "Happy Energy Solutions Ltd",
    CreatedByName: "",
    UpdatedByName: "Ryan Hayward",
    SignedOffByName: "",
    CancelledByName: "",
    EvidenceCount: 0,
    StageCount: 4,
    SiteVisitCount: 0,
    EcoStatus: 1,
    EcoMeasureName: null,
    TrustMarkUmr: null,
    SimpleMeasureDetails: null,
    RawMeasureDetails: null,
    DefaultMeasureDetails: null,
  },

  // ── 24 DOVE CRESCENT - (Status 1) ─────────────────────────────
  {
    Id: "013A71C5-DA94-4D5B-6536-08DE57F498F4",
    CreatedUtc: "2026-03-12T20:34:16Z",
    UpdatedUtc: "2026-03-12T20:34:16Z",
    JobId: "8C5EA515-CA9F-4ECE-9AE3-08DE57F5C532",
    MeasureName: null,
    MeasureStatus: 1,
    InstallUtc: null,
    HandoverUtc: null,
    SignedOffUtc: null,
    CancelledUtc: null,
    IsManual: 0,
    MeasureReference: null,
    InstallationCost: null,
    DesignCompleted: null,
    TrustMarkMeasureId: null,
    PasMeasureName: null,
    PasMeasureType: null,
    LotName: null,
    ProjectStageName: "Project Stage 1",
    ProjectStageStatus: 1,
    SubInstallerTrustMarkLicenceNumber: null,
    JobUId: "60871047",
    SingleLineAddress: "24 DOVE CRESCENT HARWICH ESSEX CO12 4QY",
    AddressPostcode: "CO12 4QY",
    JobStatusId: 1,
    JobTypeId: 1,
    CompanyId: "DA9F3718-FAD0-468B-A98B-08D7F19416B3",
    CompanyName: "Happy Energy Solutions Ltd",
    CreatedByName: "",
    UpdatedByName: "",
    SignedOffByName: "",
    CancelledByName: "",
    EvidenceCount: 0,
    StageCount: 4,
    SiteVisitCount: 0,
    EcoStatus: 1,
    EcoMeasureName: null,
    TrustMarkUmr: null,
    SimpleMeasureDetails: null,
    RawMeasureDetails: null,
    DefaultMeasureDetails: null,
  },

  // ── 87 GORING ROAD - (Status 1) ───────────────────────────────
  {
    Id: "18DD1154-D4D1-4F07-6299-08DE57F498F4",
    CreatedUtc: "2026-03-11T21:42:48Z",
    UpdatedUtc: "2026-03-11T21:42:48Z",
    JobId: "70EB296B-F10B-4036-9AE4-08DE57F5C532",
    MeasureName: null,
    MeasureStatus: 1,
    InstallUtc: null,
    HandoverUtc: null,
    SignedOffUtc: null,
    CancelledUtc: null,
    IsManual: 0,
    MeasureReference: null,
    InstallationCost: null,
    DesignCompleted: null,
    TrustMarkMeasureId: null,
    PasMeasureName: null,
    PasMeasureType: null,
    LotName: null,
    ProjectStageName: "Project Stage 1",
    ProjectStageStatus: 1,
    SubInstallerTrustMarkLicenceNumber: null,
    JobUId: "60871048",
    SingleLineAddress: "87 GORING ROAD COLCHESTER ESSEX CO4 0DA",
    AddressPostcode: "CO4 0DA",
    JobStatusId: 1,
    JobTypeId: 1,
    CompanyId: "DA9F3718-FAD0-468B-A98B-08D7F19416B3",
    CompanyName: "Happy Energy Solutions Ltd",
    CreatedByName: "",
    UpdatedByName: "",
    SignedOffByName: "",
    CancelledByName: "",
    EvidenceCount: 0,
    StageCount: 4,
    SiteVisitCount: 0,
    EcoStatus: 1,
    EcoMeasureName: null,
    TrustMarkUmr: null,
    SimpleMeasureDetails: null,
    RawMeasureDetails: null,
    DefaultMeasureDetails: null,
  },

  // ── 6 FERNLEA ROAD - (Status 1) ───────────────────────────────
  {
    Id: "1CB6DAF4-380C-472E-6269-08DE57F498F4",
    CreatedUtc: "2026-03-11T20:33:51Z",
    UpdatedUtc: "2026-03-11T20:33:51Z",
    JobId: "E110CC45-DB64-4A7C-4378-08DE10D817D7",
    MeasureName: null,
    MeasureStatus: 1,
    InstallUtc: null,
    HandoverUtc: null,
    SignedOffUtc: null,
    CancelledUtc: null,
    IsManual: 0,
    MeasureReference: null,
    InstallationCost: null,
    DesignCompleted: null,
    TrustMarkMeasureId: null,
    PasMeasureName: null,
    PasMeasureType: null,
    LotName: null,
    ProjectStageName: "Project Stage 1",
    ProjectStageStatus: 1,
    SubInstallerTrustMarkLicenceNumber: null,
    JobUId: "60849049",
    SingleLineAddress: "6 FERNLEA ROAD HARWICH ESSEX CO12 3BW",
    AddressPostcode: "CO12 3BW",
    JobStatusId: 1,
    JobTypeId: 1,
    CompanyId: "DA9F3718-FAD0-468B-A98B-08D7F19416B3",
    CompanyName: "Happy Energy Solutions Ltd",
    CreatedByName: "",
    UpdatedByName: "",
    SignedOffByName: "",
    CancelledByName: "",
    EvidenceCount: 0,
    StageCount: 4,
    SiteVisitCount: 0,
    EcoStatus: 1,
    EcoMeasureName: null,
    TrustMarkUmr: null,
    SimpleMeasureDetails: null,
    RawMeasureDetails: null,
    DefaultMeasureDetails: null,
  },

  // ── 18 LOVE LANE - (Status 4) ─────────────────────────────────
  {
    Id: "9474C525-5962-45B4-A84A-08DE57F6FBBF",
    CreatedUtc: "2026-03-11T10:44:49Z",
    UpdatedUtc: "2026-03-31T11:42:17Z",
    JobId: "4B86B0F6-EC98-46B4-363B-08DE4D6F3396",
    MeasureName: null,
    MeasureStatus: 4,
    InstallUtc: "2026-03-19T00:00:00Z",
    HandoverUtc: "2026-03-20T00:00:00Z",
    SignedOffUtc: null,
    CancelledUtc: null,
    IsManual: 1,
    MeasureReference: null,
    InstallationCost: null,
    DesignCompleted: 1,
    TrustMarkMeasureId: null,
    PasMeasureName: null,
    PasMeasureType: null,
    LotName: null,
    ProjectStageName: "Project Stage 1",
    ProjectStageStatus: 4,
    SubInstallerTrustMarkLicenceNumber: null,
    JobUId: "60858751",
    SingleLineAddress: "18 LOVE LANE RAYLEIGH ESSEX SS6 7DL",
    AddressPostcode: "SS6 7DL",
    JobStatusId: 4,
    JobTypeId: 1,
    CompanyId: "DA9F3718-FAD0-468B-A98B-08D7F19416B3",
    CompanyName: "Happy Energy Solutions Ltd",
    CreatedByName: "",
    UpdatedByName: "",
    SignedOffByName: "",
    CancelledByName: "",
    EvidenceCount: 2,
    StageCount: 4,
    SiteVisitCount: 0,
    EcoStatus: 1,
    EcoMeasureName: null,
    TrustMarkUmr: null,
    SimpleMeasureDetails: null,
    RawMeasureDetails: null,
    DefaultMeasureDetails: null,
  },
];

/**
 * Demo recommended measures (MeasureModel) keyed by JobId.
 * Based on real EPC recommendation data structure.
 */
export const DEMO_RECOMMENDATIONS = {
  // 15 POPLAR ROAD job
  "2AD6F2BE-968D-4146-4306-08DE10D817D7": [
    {
      Id: "EB3DE33B-F77A-405E-B856-08DAB59230C4",
      JobId: "2AD6F2BE-968D-4146-4306-08DE10D817D7",
      MeasureModelName: "Floor Insulation (Suspended Floor)",
      MeasureEpcLetter: "W1",
      InstallationCost: 1000.00,
      AnnualFuelSaving: 66.00,
      RepaymentPeriod: 15.15,
      CarbonCostEffectiveness: -105.48,
      PotentialEnergyRating: 69,
      PotentialEnvironmentImpactRating: 64,
      Lifetime: 42,
      AnnualCo2: 0.40,
      LifetimeCo2: 16.80,
      RenewableTechnologies: false,
      ManuallyAdded: false,
      MeasureModelType: 1,
    },
    {
      Id: "AAC66B1A-C9EF-4933-B857-08DAB59230C4",
      JobId: "2AD6F2BE-968D-4146-4306-08DE10D817D7",
      MeasureModelName: "Solar Water Heating",
      MeasureEpcLetter: "N",
      InstallationCost: 5000.00,
      AnnualFuelSaving: 45.00,
      RepaymentPeriod: 111.11,
      CarbonCostEffectiveness: 516.67,
      PotentialEnergyRating: 68,
      PotentialEnvironmentImpactRating: 63,
      Lifetime: 25,
      AnnualCo2: 0.30,
      LifetimeCo2: 7.50,
      RenewableTechnologies: true,
      ManuallyAdded: false,
      MeasureModelType: 1,
    },
    {
      Id: "EF8235ED-0A9B-43AC-B858-08DAB59230C4",
      JobId: "2AD6F2BE-968D-4146-4306-08DE10D817D7",
      MeasureModelName: "Photovoltaics",
      MeasureEpcLetter: "U",
      InstallationCost: 0.00,
      AnnualFuelSaving: 0.00,
      RepaymentPeriod: 25.00,
      CarbonCostEffectiveness: 180.00,
      PotentialEnergyRating: 75,
      PotentialEnvironmentImpactRating: 69,
      Lifetime: 25,
      AnnualCo2: 1.00,
      LifetimeCo2: 25.00,
      RenewableTechnologies: true,
      ManuallyAdded: false,
      MeasureModelType: 1,
    },
  ],
  // 18 LOVE LANE job
  "AF6C539B-8792-4878-429B-08DE10D817D7": [
    {
      Id: "0321559E-67D4-42A0-68CE-08DAB6D7A05F",
      JobId: "AF6C539B-8792-4878-429B-08DE10D817D7",
      MeasureModelName: "Party Wall Insulation",
      MeasureEpcLetter: "B4",
      InstallationCost: 450.00,
      AnnualFuelSaving: 122.00,
      RepaymentPeriod: 3.69,
      CarbonCostEffectiveness: -158.98,
      PotentialEnergyRating: 24,
      PotentialEnvironmentImpactRating: 23,
      Lifetime: 42,
      AnnualCo2: 0.70,
      LifetimeCo2: 29.40,
      RenewableTechnologies: false,
      ManuallyAdded: false,
      MeasureModelType: 1,
    },
    {
      Id: "569891F3-15B5-41BC-68CF-08DAB6D7A05F",
      JobId: "AF6C539B-8792-4878-429B-08DE10D817D7",
      MeasureModelName: "Floor Insulation (Solid Ground Floor)",
      MeasureEpcLetter: "W2",
      InstallationCost: 5000.00,
      AnnualFuelSaving: 161.00,
      RepaymentPeriod: 31.06,
      CarbonCostEffectiveness: -46.61,
      PotentialEnergyRating: 26,
      PotentialEnvironmentImpactRating: 24,
      Lifetime: 42,
      AnnualCo2: 0.90,
      LifetimeCo2: 37.80,
      RenewableTechnologies: false,
      ManuallyAdded: false,
      MeasureModelType: 1,
    },
    {
      Id: "87BAA7A7-BBB8-4D39-68D1-08DAB6D7A05F",
      JobId: "AF6C539B-8792-4878-429B-08DE10D817D7",
      MeasureModelName: "Change Heating to Condensing Gas Condensing Boiler (No Fuel Switch)",
      MeasureEpcLetter: "S",
      InstallationCost: 8000.00,
      AnnualFuelSaving: 1233.00,
      RepaymentPeriod: 6.49,
      CarbonCostEffectiveness: -97.64,
      PotentialEnergyRating: 71,
      PotentialEnvironmentImpactRating: 69,
      Lifetime: 12,
      AnnualCo2: 5.80,
      LifetimeCo2: 69.60,
      RenewableTechnologies: false,
      ManuallyAdded: false,
      MeasureModelType: 1,
    },
    {
      Id: "7EF4C181-BB8A-4ED6-68D2-08DAB6D7A05F",
      JobId: "AF6C539B-8792-4878-429B-08DE10D817D7",
      MeasureModelName: "Solar Water Heating",
      MeasureEpcLetter: "N",
      InstallationCost: 5000.00,
      AnnualFuelSaving: 243.00,
      RepaymentPeriod: 20.58,
      CarbonCostEffectiveness: -61.43,
      PotentialEnergyRating: 26,
      PotentialEnvironmentImpactRating: 23,
      Lifetime: 25,
      AnnualCo2: 0.70,
      LifetimeCo2: 17.50,
      RenewableTechnologies: true,
      ManuallyAdded: false,
      MeasureModelType: 1,
    },
    {
      Id: "631758DC-FE2D-415C-68D3-08DAB6D7A05F",
      JobId: "AF6C539B-8792-4878-429B-08DE10D817D7",
      MeasureModelName: "Photovoltaics",
      MeasureEpcLetter: "U",
      InstallationCost: 4500.00,
      AnnualFuelSaving: 43.00,
      RepaymentPeriod: 104.65,
      CarbonCostEffectiveness: 114.17,
      PotentialEnergyRating: 30,
      PotentialEnvironmentImpactRating: 25,
      Lifetime: 25,
      AnnualCo2: 1.20,
      LifetimeCo2: 30.00,
      RenewableTechnologies: true,
      ManuallyAdded: false,
      MeasureModelType: 1,
    },
    {
      Id: "7D69B8D7-991D-4911-68D5-08DAB6D7A05F",
      JobId: "AF6C539B-8792-4878-429B-08DE10D817D7",
      MeasureModelName: "Air or Ground Source Heat Pump",
      MeasureEpcLetter: "Z1",
      InstallationCost: 6500.00,
      AnnualFuelSaving: 43.00,
      RepaymentPeriod: 151.16,
      CarbonCostEffectiveness: 940.00,
      PotentialEnergyRating: 22,
      PotentialEnvironmentImpactRating: 20,
      Lifetime: 20,
      AnnualCo2: 0.30,
      LifetimeCo2: 6.00,
      RenewableTechnologies: true,
      ManuallyAdded: false,
      MeasureModelType: 1,
    },
  ],
};
